import { playFocus } from 'app/ui-components/utils.styles';
import styled, { css } from 'styled-components';
import { device, deviceGte } from 'app/ui-components/breakpoints';
import { playFontSize } from 'app/ui-components/typography/helpers';
import { fontWeightBold, regularWhite } from '../../../../ui-components/design-tokens';

type ListItemProps = {
    type: string;
};

export const ListItem = styled.li`
    margin: 0;

    &:first-of-type {
        margin-left: 0;
    }

    @media ${deviceGte(380)} {
        /* margin: 0; */
    }

    @media ${device.GteSmall} {
        position: relative;
    }

    ${(props: ListItemProps) =>
        props.type === 'search' &&
        css`
            @media ${device.GteSmall} {
                display: none;
            }
        `}
`;

export const SharedMenuLinkStyle = css`
    letter-spacing: 0.5px;
    color: ${regularWhite};
    text-transform: uppercase;
    text-decoration: none;
    line-height: 1;
    padding: 8px 2px;

    ${playFontSize(1.3)}
    ${playFocus()}

    &:hover,
    &:active,
    &:visited {
        color: ${regularWhite};
    }

    &:hover {
        .no-touchevents && {
            text-decoration: underline;
        }
    }

    @media ${deviceGte(380)} {
        ${playFontSize(1.5)}
        padding: 10px 8px;
    }

    @media ${device.GteMedium} {
        ${playFontSize(1.6)}
        padding: 10px 15px;
    }
`;

type LinkProps = {
    isActive: boolean;
};

export const Link = styled.a<LinkProps>`
    ${SharedMenuLinkStyle};

    ${(props: LinkProps) =>
        props.isActive &&
        css`
            font-weight: ${fontWeightBold};
        `}
`;
